import { FormEvent } from 'react'
import { useNavigate } from 'react-router'
import { useAccountRoleCreate } from '../api/account-roles'
import { AccountRolesForm } from './account-roles-form'

export function AccountRolesCreate() {
	const navigate = useNavigate()
	const { mutate, isPending } = useAccountRoleCreate()

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form), {
			onSuccess: () => {
				form.reset()
				navigate('../')
			},
		})
	}

	return <AccountRolesForm onSubmit={onSubmit} isPending={isPending} />
}
